import { render, staticRenderFns } from "./ActivityDurationPDP.vue?vue&type=template&id=b5158920&scoped=true&"
import script from "./ActivityDurationPDP.vue?vue&type=script&lang=js&"
export * from "./ActivityDurationPDP.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDurationPDP.vue?vue&type=style&index=0&id=b5158920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5158920",
  null
  
)

export default component.exports